import React, { useEffect, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import VENDOR_PROMOTION_FORM from "../../constants/vendorStepsForm";
import { useNavigate, useParams } from "react-router-dom";
import useActivePromotion from "../../hooks/useActivePromotion";
import useEditPromotion from "../../hooks/useEditPromotion";
import CustomToast from "src/components/CustomToast/CustomToast";
import { toast } from "react-toastify";
import adaptEditBanner from "src/features/HomepageCarouselBanners/adapters/adaptEditBanner";
import adaptPromotionForm from "../../adapters/adaptPromotionForm/adaptPromotionForm";

const EditPromotion = () => {
	const navigate = useNavigate();
	const { formId } = useParams<{ formId: number }>();

	const [defaultValues, setDefaultValues] = useState<BannerFormState>({
		bannerStyle: "standard",
		bannerType: "fullScreenTakeoverBanner",
		selectedHashtag: null,
		steps: VENDOR_PROMOTION_FORM
	});

	const { data: banner } = useActivePromotion(formId);

	const { mutate: editForm } = useEditPromotion();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Edited Successfully" />);
		navigate("/vendor-sponsorship/promotion/banners?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error editing the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, EDIT FORM", { formId, data });

		editForm(adaptEditBanner(formId, data), {
			onSuccess,
			onError
		});
	};

	useEffect(() => {
		console.log({ banner, formId });

		if (formId && banner) {
			console.log("FETCH DEFAULT VALUES", {
				...defaultValues,
				bannerType: banner.template,
				steps: adaptPromotionForm(banner)
			});

			setDefaultValues({
				...defaultValues,
				bannerType: banner.template,
				steps: adaptPromotionForm(banner)
			});
		}
	}, [banner, formId]);

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["promotionImage", "promotionVideo"]}
			showVariantTab={false}
			root="promotion"
		/>
	);
};

export default EditPromotion;
